import { registerPlugin } from '@capacitor/core'
import type { IDnowPluginInterface, IDnowAutoIdentPluginInterface } from './definitions'

export const IDnowPlugin = registerPlugin<IDnowPluginInterface>('IDnowPlugin')
export const IDnowAutoIdentPlugin = registerPlugin<IDnowAutoIdentPluginInterface>('IDnowAutoIdentPlugin')

export type {
	IDnowStartOptions,
	IDnowAutoIdentOptions,
	IDnowResult,
	IDnowPluginInterface,
	IDnowAutoIdentPluginInterface,
} from './definitions'
